import React from "react";

function RelatedSearches({ relatedTerms, onSelect }) {
  if (!relatedTerms || relatedTerms.length === 0) return null;

  return (
    <div className="suggested-search-content">
      <div className="suggested-search">
        <span className="label related-searches-lead">You may also be interested in: &nbsp;</span>
        <div className="related-searches-container">
          {relatedTerms.map((term, index) => (
            <span key={term.code || index} className="related-search">
              <a
                className="related-link"
                role="button"
                tabIndex={0}
                onClick={() => onSelect(term)}
              >
                {term.name}
              </a>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RelatedSearches;
